import { RecordCard, RecordRow } from "./RecordCard";
import { MUTED } from "./styles";

/** A record's id in another system (external_ids, 0022, W15 M6). */
export interface ExternalId {
  id: string;
  system: string;
  system_label: string;
  value: string;
}

/** The record's ids in Encompass, HubSpot, Brivity, Place … Read-only. */
export function ExternalIdsCard({ ids }: { ids?: ExternalId[] }) {
  if (!ids?.length) return null;
  return (
    <RecordCard title="Other systems" count={ids.length}>
      <ul>
        {ids.map((e) => (
          <RecordRow
            key={e.id}
            primary={
              <>
                <span className={MUTED}>{e.system_label}</span>{" "}
                <span className="break-all">{e.value}</span>
              </>
            }
          />
        ))}
      </ul>
    </RecordCard>
  );
}
